export const signin = 'login';
export const signup = 'register';
export const verifyEmail = 'verify/email';
export const userProfile = 'users/me';
export const updateUserProfile = 'users/me';
export const getUploadURL = 'uploadurl';
export const forgotpassword = 'forgotpass';
export const resetPassword = 'reset/password';
export const changePassword = 'changePass';
export const getStripeCustomerId = 'customer';
export const updatePaymentMethod = 'customer';
export const subscribePlan = 'customer/subscription';
export const userPlan = 'user-plan'
export const getAllPlans = 'plans';
export const resendVerification = 'resendverify';
export const verifyPocket = 'token';
export const getTwitterLoginRequestCode = 'request_token'
export const socialAccounts = 'accounts'
export const remove = 'remove'
export const checkSubscription = 'check-subscription'
export const synchronize = 'synchronize'
export const update = 'update'
export const originList = 'origin-list'
//Information portal
export const getAllFollowingList = 'all';
export const getAllAuthorList = 'author';
export const getContents = 'contents'; 
export const getContent = 'content'; 
export const getList = 'list'
export const totalCount = 'total-count'
export const articles = 'articles'
export const collections = 'collections'
export const dossiers = 'dossiers'
export const collectionDetail = 'collection-articles'
export const dossierDetail = "dossier-articles"
export const dossier = 'dossier'
export const collectionFilter = 'collection-filter'
export const dossierFilter = 'dossier-filter'
export const followings = 'followings'
export const create = 'create'
export const slug = 'slug'
export const unique = 'unique'
export const uniqueUrl = 'url-unique'
export const publicationFilter = 'pb-filter-data'
export const authorFilter = 'au-filter-data'
export const followersCount = 'followers-count'
export const followersUserCount = 'followers-users'
export const oldNewRecord = 'old-new-record'
export const twitter = 'twitter'
export const addViaExtension = 'addViaExtension'
export const addDocument = 'add-document'
export const organisation = 'organisation'
export const team = 'team'
export const emailAction = 'email-action'
export const people = 'people'
export const fieldFilter = 'field-filter'
export const paymentMethod = 'payment-method'
export const changeRole = 'change-role'
export const pendingInvitationList = 'pending-invitation-list'
export const cancelInvitation = 'cancel-invitation'
export const failedInvitationList = 'failed-invitation-list'
export const donationTier = 'donation-tier'
export const featureWork = 'feature-work'
export const verifyDomainDns = 'verify-domain-dns'
export const verifyHtmlFile = 'verify-html-file'
export const verifyMetaTag = 'verify-meta-tag'
export const getDomainList = 'domains'
export const addDomain = 'domain'
export const getAllUsers='iam/get-all-users'
export const createUsergroup='iam/create-user-group'
export const getuserGroups='iam/get-all-group'
export const deleteUserGroup='iam/delete-user-group'
export const getGroupDetailById='iam/get-group-detail'
export const editUserGroup='iam/update-group-detail'
export const bulkEditUser='iam/bulk-edit-user'
export const bulkEditUserGroup='iam/bulk-edit-user-group'
export const userPermissions = 'iam/user-permission'
export const getPermissionPolicies = 'get-iam-policy'
